import * as React from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';

export const HeaderLink: React.FC<NavLinkProps> = (props) => (
  <li className="h2">
    <NavLink {...props} className="nav-link" />
  </li>
);
